import script from "./ConfigCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigCompany.vue?vue&type=script&setup=true&lang=js"

import "./ConfigCompany.vue?vue&type=style&index=0&id=39981d3f&lang=css&scoped=true"

import exportComponent from "C:\\laragon\\www\\unensecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39981d3f"]])

export default __exports__